import { render, staticRenderFns } from "./PageProductsCreate.vue?vue&type=template&id=cc489c78&scoped=true&"
import script from "./PageProductsCreate.vue?vue&type=script&lang=ts&"
export * from "./PageProductsCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PageProductsCreate.vue?vue&type=style&index=0&id=cc489c78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc489c78",
  null
  
)

export default component.exports